// Bouton flèche de repli des panneaux du query builder.
import React from "react";
import THEME from "../../../shared/ui/theme";

export const CollapseToggleBtn: React.FC<{
  collapsed: boolean;
  onToggle: () => void;
  title?: string;
}> = ({ collapsed, onToggle, title }) => (
  <button
    onClick={onToggle}
    title={title}
    style={{
      marginLeft: "auto",
      background: "rgba(255,255,255,0.1)",
      border: "1px solid rgba(255,255,255,0.15)",
      borderRadius: 8,
      cursor: "pointer",
      color: "rgba(255,255,255,0.75)",
      fontSize: 12,
      padding: "3px 8px",
      fontFamily: THEME.fonts.body,
      transition: "background 0.15s",
      flexShrink: 0,
    }}
    onMouseEnter={(e) =>
      ((e.currentTarget as HTMLElement).style.background =
        "rgba(255,255,255,0.22)")
    }
    onMouseLeave={(e) =>
      ((e.currentTarget as HTMLElement).style.background =
        "rgba(255,255,255,0.1)")
    }
  >
    {collapsed ? "▶" : "◀"}
  </button>
);
